import { render, staticRenderFns } from "./MitMyReservationsSimple.vue?vue&type=template&id=25dac825&scoped=true"
import script from "./MitMyReservationsSimple.vue?vue&type=script&lang=js"
export * from "./MitMyReservationsSimple.vue?vue&type=script&lang=js"
import style0 from "./MitMyReservationsSimple.vue?vue&type=style&index=0&id=25dac825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dac825",
  null
  
)

export default component.exports